<template>
  <div>
    <div class="container mx-auto px-4 xl:px-6 lg:mt-12">
      <div class="relative" v-if="completeData">
        <img :src="pageData.hero_image.url | getImagePath"
          :alt="pageData.hero_image.name"
          loading="lazy"
          class="object-cover w-full rounded-lg h-104">
        <div class="absolute top-0 right-0 bottom-0
        left-0 z-10 bg-black opacity-25 rounded-lg"></div>
        <div class="absolute top-0 right-0 bottom-0 left-0 z-20 h-full p-10 rounded-lg
          flex flex-col justify-center text-white text-left">
          <ebr-h1 :content="$t('boats.hero.title')" />
          <ebr-h2 :content="$t('boats.hero.subtitle')" />
          <ebr-p :classes="'my-3 lg:my-5'" :content="$t('boats.hero.text')" />
        </div>
      </div>
      <ebr-h2 :content="$t('boats.sidebar.title')" class="text-left my-10" />
      <div class="grid grid-cols-3 gap-4 mx-auto mb-16" v-if="completeBoats">
        <div class="col-span-3 lg:col-span-1 flex flex-col md:flex-row lg:flex-col">
          <ebr-round-button-with-icon
            :icon="'barca'"
            :label="$t('boats.sidebar.filters.allBoats')"
            @click.native="filterResults('all')"
            class="mb-6 w-full"
            :class="{'bg-gray-900 text-white border-black' : this.queryFilter === 'all'}"/>
          <ebr-round-button-with-icon
            :icon="'patente'"
            :label="$t('boats.sidebar.filters.withLicense')"
            @click.native="filterResults('con_patente')"
            class="mb-6 w-full"
            :class="{'bg-gray-900 text-white border-black' : this.queryFilter === 'con_patente'}"/>
          <ebr-round-button-with-icon
            :icon="'senza-patente'"
            :label="$t('boats.sidebar.filters.withoutLicense')"
            @click.native="filterResults('senza_patente')"
            class="mb-6 w-full"
            :class="{'bg-gray-900 text-white border-black'
            : this.queryFilter === 'senza_patente'}"/>
        </div>
        <div class="col-span-3 lg:col-span-2">
          <ebr-p
            :content="`${display_boats.length} ` + $tc('boats.result', display_boats.length)"
            class="text-right mx-6 mb-4 text-gray-600" />
          <ebr-boat-info-card
            class="mb-6"
            v-for="boat in display_boats"
            :key="boat.id"
            :boat="boat"
            @click.native="navigateTo(boat)" />

          <!-- <p v-for="boat in boats" :key="boat.id">
            <router-link :to="`/boat/${boat.slug}`">
              {{boat['information_'+language].name}}
            </router-link>
          </p> -->
        </div>
      </div>
    </div>
    <ebr-footer />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import H1Vue from '../components/atoms/typography/H1.vue';
import H2Vue from '../components/atoms/typography/H2.vue';
import ParagraphVue from '../components/atoms/typography/Paragraph.vue';
import RoundButtonWithIconVue from '../components/atoms/buttons/RoundButtonWithIcon.vue';
import InfoCardVue from '../components/molecules/boat/InfoCard.vue';
import FooterVue from '../components/organism/Footer.vue';

export default {
  name: 'Home',
  data() {
    return {
      boats: '',
      display_boats: '',
      pageData: '',
      completeBoats: false,
      completeData: false,
      queryFilter: 'all',
    };
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
  },
  methods: {
    navigateTo(boat) {
      this.$router.push({ path: `/boat/${boat.slug}`, query: { lang: this.language } });
    },
    fetchBoats() {
      axios.get('/boats?_sort=slug:asc')
        .then((response) => {
          this.boats = response.data;
          if (this.display_boats === '') {
            this.display_boats = this.boats;
          }
          this.filterResults(this.queryFilter);
          if (this.queryFilter) {
            this.filterResults(this.queryFilter);
          } else {
            this.filterResults('all');
          }
          this.completeBoats = true;
        });
    },
    filterResults(filter) {
      this.queryFilter = filter;
      if (filter === 'all') {
        this.display_boats = this.boats;
      } else {
        this.display_boats = this.boats.filter((boat) => boat[`information_${this.language}`].boat_type === filter);
      }
    },
  },
  mounted() {
    if (this.$route.query.filter) {
      this.queryFilter = this.$route.query.filter;
    }
    axios.get('boat-page')
      .then((response) => {
        this.pageData = response.data;
        this.completeData = true;
      });
    this.fetchBoats();
  },
  components: {
    'ebr-h1': H1Vue,
    'ebr-h2': H2Vue,
    'ebr-p': ParagraphVue,
    'ebr-round-button-with-icon': RoundButtonWithIconVue,
    'ebr-boat-info-card': InfoCardVue,
    'ebr-footer': FooterVue,
  },
};
</script>
